import { useSyncExternalStore } from "react";

const subscribeNever = () => () => {};

/** False on the server and while the browser hydrates its markup, true after that. */
const useIsClient = (): boolean =>
	useSyncExternalStore(
		subscribeNever,
		() => true,
		() => false,
	);

export default useIsClient;
